import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["componentEl", "margin", "className", "text", "maxlen", "maxlines"];
import React from 'react';
import PropTypes from 'prop-types';
import { componentElPropTypes } from '../customPropTypes/componentEl';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes } from '../customPropTypes/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
/**
Fallback for when we don't have logos
*/
function LogoFallback(_ref) {
  var ComponentEl = _ref.componentEl,
    margin = _ref.margin,
    className = _ref.className,
    text = _ref.text,
    maxlen = _ref.maxlen,
    maxlines = _ref.maxlines,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_logofallback'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  var words = text.split(' ');
  var finalText = [];
  var maxlenReached = false;
  words.forEach(function (w) {
    if (w.length > maxlen) {
      finalText = finalText.concat(w.match(new RegExp(".{1,".concat(maxlen, "}"), 'g')));
      maxlenReached = true;
    } else {
      finalText.push(w);
    }
  });
  if (maxlines) {
    finalText = finalText.slice(0, maxlines);
  }
  if (finalText.length > 3 || maxlen > 3 && maxlenReached) {
    cssClasses.push('st_logofallback--xs');
  }
  return /*#__PURE__*/_jsx(ComponentEl, _extends({
    "aria-label": text,
    className: cssClasses.join(' ')
  }, otherProps, {
    children: finalText.map(function (w) {
      return /*#__PURE__*/_jsx("span", {
        children: w
      }, w);
    })
  }));
}
process.env.NODE_ENV !== "production" ? LogoFallback.propTypes = {
  /**
   * Text to display for fallback brand */
  text: PropTypes.string.isRequired,
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** max number of characters per line */
  maxlen: PropTypes.number,
  /** max number of lines, if any */
  maxlines: PropTypes.number
} : void 0;
LogoFallback.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  maxlen: 5,
  maxlines: 3
};
export default LogoFallback;